import { DataBean } from "../DataBean";

export class ProductTransl extends DataBean {



    public async getProductTranslateConceptCatalog(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductTranslateConceptCatalog_Number", [id]);
    }

    public async deleteProductTranslateConcept(idProductTranslateConcept: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteProductTranslateConcept_Number", [idProductTranslateConcept]);
    }


    public async updateProductTranslateConcept(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.ProductTranslateConcept_updateProductTranslateConcept_com.quickdataerp.bean.inventory.ProductTranslateConcept", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.inventory.ProductTranslateConcept"
            }
        ]);
    }

}